// 创建 el-menu-item
export function elMenuItem(createElement, menu) {
  return createElement("el-menu-item", { props: { index: menu.path } }, [
    ...(menu.icon
      ? [createElement("i", { attrs: { class: `el-icon-${menu.icon}` } })]
      : []),
    ...(menu.icon === undefined && !menu.iconSvg && menu.title == "总览"
      ? [
          // createElement('img', { attrs: { src: './menuIcon/' + menu.path.slice(1) + '.png' } })
          // public 文件需要使用绝对路径引入
          createElement("img", {
            attrs: {
              src:
                `${process.env.VUE_APP_PUBLIC_PATH}menuIcon/` +
                menu.path.slice(1) +
                ".png",
              width: "22px",
              height: "20px"
            }
          })
        ]
      : []),
    ...(menu.iconSvg
      ? [createElement("d2-icon-svg", { props: { name: menu.iconSvg } })]
      : []),
    createElement("span", { slot: "title" }, menu.title || "未命名菜单")
  ])
}

// 创建 el-submenu
export function elSubmenu(createElement, menu) {
  return createElement("el-submenu", { props: { index: menu.path } }, [
    ...(menu.icon
      ? [
          createElement("i", {
            slot: "title",
            attrs: { class: `el-icon-${menu.icon}` }
          })
        ]
      : []),
    ...((menu.icon === undefined) & !menu.iconSvg
      ? [
          // createElement('img', { slot: 'title', attrs: { src: './menuIcon/' + menu.path.slice(1) + '.png' } })
          // public 文件需要使用绝对路径引入
          createElement("img", {
            slot: "title",
            attrs: {
              src:
                `${process.env.VUE_APP_PUBLIC_PATH}menuIcon/` +
                menu.path.slice(1) +
                ".png",
              width: "22px",
              height: "20px"
            }
          })
        ]
      : []),
    ...(menu.iconSvg
      ? [
          createElement("d2-icon-svg", {
            slot: "title",
            props: { name: menu.iconSvg }
          })
        ]
      : []),
    createElement("span", { slot: "title" }, menu.title || "未命名菜单"),
    ...menu.children.map((child, childIndex) =>
      child.sideHidden
        ? ""
        : (child.children === undefined ? elMenuItem : elSubmenu).call(
            this,
            createElement,
            child
          )
    )
  ])
}
